// Framework
import { Component } from '@angular/core'

@Component({
  templateUrl: './register-verify.component.html',
  styleUrls: ['./register-verify.component.scss'],
})
export class AuthenticationRegisterVerifyComponent {}
